/*
 * @Author: 窦云飞 df1987131@yeah.net
 * @Date: 2023-02-21 10:41:30
 * @LastEditors: 窦云飞 df1987131@yeah.net
 * @LastEditTime: 2023-02-21 13:50:08
 * @FilePath: /epec-bidding/Users/douyunfei/Documents/epec-ope/src/directive/index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import debounce from './debounce';
import downLoadUrl from './downLoadUrl';
import permission from './permission';
import loadMore from './loadMore';

const install = function (Vue) {
  Vue.directive('debounce', debounce);
  Vue.directive('downLoadUrl', downLoadUrl);
  Vue.directive('permission', permission);
  Vue.directive('loadMore', loadMore);
};

export default { install };
